import React from 'react';

import Typography from '@material-ui/core/Typography';

import { UsersCard } from '../UsersCard';

export class AdminPage extends React.Component {
    render() {
        return (
            <div style={{ marginBottom: 10 }} >
                <Typography style={{ marginBottom: 10 }} variant="h5">Admin</Typography>
                <UsersCard />
            </div>
        )
    }
}
